import { fExecuteAPI } from "../../Server/Apis";
import { WmsSI_wmsSalesInvoiceAttributes_GETROW } from "../../Server/ApiV2";
import { fAlertToast, Get_TransItemStockUOM } from "../../Utility/Utilitys";
import { Wms_Invoice_HeadObject_A_PayMode_Set } from "./SliceWmsInvoice";
import { vRdxUserInfo, WmsSalesInvoiceRo } from "../../Redux/roStore";
export const sItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];
export const sTrnTyp = "WMINV08";
export const sCustomerSearchData = ["Any", "Code", "Name"];

export const sTax = [
  { Uid: "OTTRN001", Name: "VAT" },
  { Uid: "OTTRN002", Name: "Inter.Comp" },
  { Uid: "OTTRN003", Name: "Import" },
];

//ABC
var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow = vheaderArrow !== 1 ? vheaderArrow + 1 : 1;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow = vheaderArrow !== 0 ? vheaderArrow - 1 : 0;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const GetSearchItem = async (
  xData,
  xType,
  xA_Loc,
  setSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in DocLoading"
    );
  }
};

export const GetSearchCustomer = async (
  xData,
  xType,
  xA_Loc,
  setCustSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("PARTYSEARCH001_GETROW", vSeatchVendor);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setCustSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in DocLoading"
    );
  }
};

const fDefaultPayload = (xPaymode, dispatch, setPaymodeEnable) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode;
  //client req
  if (xPaymode == "BOTH") {
    setPaymodeEnable(false);
  } else {
    setPaymodeEnable(true);
  }

  dispatch(
    Wms_Invoice_HeadObject_A_PayMode_Set({
      A_PayMode: iPaymode,
    })
  );
  return iPaymode;
};
//API GET_BATCH_DETAILS_GETROW_001
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

const GetOSAmount = async (xLoc, xParty, setOsAmount) => {
  const { HeadObject } = WmsSalesInvoiceRo();
  let vOsAmtObj = {
    Loc: xLoc,
    Party: xParty,
  };
  if (HeadObject.A_DocStat === "ENTER") {
    const vOsAmt = await fExecuteAPI("Common_partyosamtt_GETROW", vOsAmtObj);
    if (
      vOsAmt?.Type?.toUpperCase() === "SUCCESS" &&
      vOsAmt?.ResultSet?.length > 0
    ) {
      setOsAmount((obj) => ({
        ...obj,
        NetOsAmt: vOsAmt.ResultSet[0].NetAmtWithoutPDC,
        PDCAmt: vOsAmt.ResultSet[0].PDCAmt,
        BalanceOsAmt: vOsAmt.ResultSet[0].NetAmtAfterPDC,
      }));
    } else {
      fAlertToast(
        "FAILED",
        vOsAmt.response.data.message || vOsAmt.response.data.Status
      );
    }
  } else {
    setOsAmount((obj) => ({
      ...obj,
      NetOsAmt: 0,
      PDCAmt: 0,
      BalanceOsAmt: 0,
    }));
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setSupervisorSlabs,
  setOtherSlabs,
  setCurrency,
  setSalesman
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await WmsSI_wmsSalesInvoiceAttributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setSalesman(iAttributes?.data?.ResultSet?.Salesman);
    setSupervisorSlabs(iAttributes?.data?.ResultSet?.SupervisorSlabs);
    setOtherSlabs(iAttributes?.data?.ResultSet?.OtherSlabs);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export {
  GetOSAmount,
  fRightClick,
  fLeftClick,
  fDefaultPayload,
  Get_GCSearchBtn,
};
